import React, { Component } from 'react'
import { withStyles } from '@material-ui/core/styles'

// COMPONENTS
import Typography from '@material-ui/core/Typography'
import { ButtonContained } from '../components/app-button/button'
import cx from 'classnames'
import AppBarInner from '../components/app-bar/AppBarInner'
import AppStepper from '../components/app-stepper'
import LeftNavigationDashboard from '../components/app-navigation/LeftNavigationDashboard'
import CustomizeAll from '../components/сustomize-all/'
import Checkbox from '@material-ui/core/Checkbox'

const styles = theme => ({
  pageTemplate: {
    maxWidth: 1072,
    margin: '0 auto',
  },
  wizardRow: {
    padding: '0 24px',
    display: 'flex',
    alignItems: 'flex-start',
    justifyContent: 'flex-start',
  },
  wizardContent: {
    maxWidth: 410,
    marginLeft: 74,
  },
  paragraph: {
    marginBottom: 32,
  },
  subtitle: {
    marginBottom: 16,
  },
  paymentOffer: {
    display: 'flex',
    marginBottom: 24,
  },
  paymentOfferLink: {
    color: '#000000',
    textDecoration: 'underline',
  },
})

function getSteps() {
  return [
    `Аккаунт \nподтвержден`,
    'Сайт \nдобавлен',
    'Google Analytics \nнастроен',
    'Добавьте каналы \nдля сбора данных \nо расходах',
    'Подключение CRM\nсистемы',
    'Подключение\nколлтрекинга',
  ]
}

class Card extends Component {
  state = {
    activeStep: 7,
    isAgree: false,
    trialExpirationDate: window.state.trialExpirationDate,
  }

  handleChange = event => {
    this.setState({
      isAgree: event.target.checked,
    })
  }

  render() {
    const { classes } = this.props
    const steps = getSteps()

    return (
      <div className={classes.pageTemplate}>
        <AppBarInner />
        <CustomizeAll />

        <div className={classes.wizardRow}>
          <LeftNavigationDashboard />
          <div style={{ width: 200 }}>
            <AppStepper activeStep={this.state.activeStep} steps={steps} />
          </div>
          <div className={classes.wizardContent}>
            <Typography
              component="p"
              variant="body1"
              className={classes.paragraph}
            >
              Чтобы получить бесплатный доступ к полному функционалу системы,
              добавьте платежную карту.
            </Typography>

            <Typography
              component="p"
              variant="body1"
              className={classes.paragraph}
            >
              Попробуйте ROMI center бесплатно, чтобы понять, подходит ли он
              вам. Никаких платежей до окончания пробного периода{' '}
              {this.state.trialExpirationDate}.
            </Typography>

            <Typography
              component="p"
              variant="subtitle1"
              className={classes.subtitle}
            >
              Вы сможете отменить подписку в личном кабинете, и удалить карту
              в любой момент.
            </Typography>

            <Typography
              component="p"
              variant="subtitle1"
              className={classes.subtitle}
            >
              При удалении карты во время платного периода вы сможете
              использовать систему в полном объеме, пока не наступит время
              следующего платежа.
            </Typography>

            <Typography
              component="p"
              variant="subtitle1"
              className={classes.subtitle}
            >
              Для привязки карты мы спишем и вернем вам 1 рубль.
            </Typography>

            <div className={classes.paymentOffer}>
              <Checkbox
                checked={this.state.isAgree}
                color="secondary"
                onChange={this.handleChange}
              />
              <Typography component="p" variant="body1">
                Я согласен с условиями{' '}
                <a
                  href="/recurring.pdf?26022020"
                  className={classes.paymentOfferLink}
                >
                  “Оферты регулярных платежей”
                </a>
              </Typography>
            </div>

            <ButtonContained
              style={{
                height: 60,
                fontSize: 16,
                width: '100%',
                padding: 0,
              }}
              type="submit"
              color="primary"
              text="Добавить платежную карту"
              disabled={this.state.isAgree ? false : true}
              href="/wizard/card/add"
            />
          </div>
        </div>
      </div>
    )
  }
}

export default withStyles(styles)(Card)
